import React from "react"
import { Link, graphql } from "gatsby"

import AboutText from "../components/about-text"
import Header from "../components/header"
import SEO from "../components/seo"

import "./home.css"
import Footer from "../components/footer"

const Home = ({
  // pageContext,
  data: {
    allMarkdownRemark: { edges },
  },
}) => (
  <>
    <SEO title="Home" />
    <Header hideOnMobile={false} />

    <section className="hero masthead">
      <div className="container">
        <h1>Steve Baker</h1>
        <h2>
          <em>
            Senior Software Developer <br /> Technical Consultant
          </em>
        </h2>
        {/* <a href="#/about">Find out more</a> */}
      </div>
    </section>

    <section className="about" id="about">
      <div className="container">
        <h2>Experienced Web Developer & Software Engineer</h2>
        <AboutText />
      </div>
    </section>

    <section className="primary posts">
      <h2>Latest Blog Posts</h2>

      <div className="container">
        {edges.map(({ node: post }) => (
          <div className="post post-card" key={post.id}>
            <div className="post-meta">{post.frontmatter.date}</div>
            <Link to={getPostLink(post)} >{post.frontmatter.title}</Link>
            <p>{post.excerpt}</p>
          </div>
        ))}
      </div>

      <Link className="btn btn-dark" to="/blog">
        More Blog Posts
      </Link>
    </section>

    <section className="skills" hidden>
      <h2>My Skills</h2>
    </section>
    <Footer></Footer>
  </>
)

const getPostLink = node => {
  const path = node.frontmatter.permalink
  return "/blog" + path
}

export default Home

export const pageQuery = graphql`
  query {
    allMarkdownRemark(
      limit: 2
      sort: { order: DESC, fields: [frontmatter___date] }
    ) {
      edges {
        node {
          id
          excerpt(pruneLength: 200)
          frontmatter {
            date(formatString: "MMMM DD, YYYY")
            permalink
            title
          }
        }
      }
    }
  }
`
